<template>
  <div class="sys-essay">
    <HeaderMenu @add="addModal('add')"
                @menuClick="menuClick"
                @moduleClick="moduleClick"
                @titleClick="titleClick"
                :options="moduleList"></HeaderMenu>
    <div class="table-content">
      <Table ref="table"
             :options="fields"
             :tableValue="tableValue"
             :customSlotOpt="slotOpt"
             :otherOpt="customOtherOpt"
             @change="initTableValue"
             @actionClick="handlerActionClick"
             :scroll="{ x: 1300, y: `calc(100vh - ${300 + 'px'})` }"></Table>
    </div>
    <essayModal :visible="visible"
                @shut="shutModal"
                :options="moduleList"
                @addSuccess="addSuccess"
                :title="title"
                :rows="rows"></essayModal>
    <Detail :title="title"
            :rows="rows"
            :visible="detailVisible"
            @shut="shutModal"
            :options="moduleList"
            @showEdit="edit(rows)"
            @offline="offline(rows)"></Detail>
  </div>
</template>

<script>
import HeaderMenu from './components/HeaderMenu.vue'
import essayModal from './components/essayModal.vue'
import Table from '@/views/Back/components/table/index.vue'
import { slotOpt, fields } from './config/config'
import mixinsBackStack from '@/views/Back/mixins'
import {
  getEssayList,
  getModuleList,
  editStatus,
  editExisted,
  deleteExisted
} from '@/api/back-essay'
import Detail from './components/detail.vue'

export default {
  mixins: [mixinsBackStack],
  components: {
    HeaderMenu,
    essayModal,
    Table,
    Detail
  },
  data() {
    return {
      visible: false,
      fields, //表格表头
      slotOpt, //操作栏选项
      tableValue: [],
      customOtherOpt: {
        pagination: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      essayStatus: '', //搜索文章发布状态参数
      moduleId: '', //搜索模块id参数
      essayTitle: '', //搜索title参数
      params: {}, //菜单栏检索信息参数汇总
      moduleList: [], //模块筛选列表
      title: '新增',
      rows: {},
      detailVisible: false, // 详情
      delFlag: '', // 已删除的状态
      statusArray: null,
      status: ''
    }
  },
  mounted() {
    this.initModuleList()
  },
  methods: {
    edit(rows) {
      this.title = '编辑'
      this.rows = rows
      this.detailVisible = false
      this.addModal()
    },
    //菜单弹出事件
    addModal(val) {
      if (val) {
        this.rows = {}
        this.title = '新增'
      }
      this.visible = true
    },
    //关闭弹出事件
    shutModal() {
      this.visible = false
      this.detailVisible = false
    },
    addSuccess() {
      this.shutModal()
      //this.reset()
      this.initModuleList()
      this.moduleList = []
    },
    // 请求前的参数收集
    handlerBeforeRequestParams() {
      this.status = this.essayStatus === '' ? null : this.essayStatus
      if (this.essayStatus === '1') {
        this.statusArray = ['1', '2']
        this.status = ''
      } else {
        this.statusArray = null
      }
      const { pagination } = this.$refs.table
      console.log('pagination', pagination)
      const { pageSize, pageNum } = pagination
      const params = {
        status: this.status,
        moduleId: this.moduleId,
        title: this.essayTitle,
        delFlag: this.delFlag,
        pageNum,
        pageSize,
        statusArray: this.statusArray
      }
      return params
    },
    async initTableValue() {
      const params = this.handlerBeforeRequestParams()
      const res = await getEssayList(params)
      this.tableValue = res.rows
      // 待发布--编辑时间
      this.tableValue.forEach((item) => {
        switch (item.status) {
          case 0:
            item.statusStr = '已发布'
            item.time = item.createTime
            item.timeStr = '发布时间'
            item.actionList = [
              {
                name: '查看',
                cb: 'detail',
                divider: false
              },
              {
                name: '下线',
                cb: 'offline',
                divider: true
              }
            ]
            break
          case 1:
            item.statusStr = '待发布'
            item.time = item.updateTime
            item.timeStr = '编辑时间'
            item.actionList = [
              {
                name: '编辑',
                cb: 'edit',
                divider: false
              },
              {
                name: '发布',
                cb: 'release',
                divider: true
              }
            ]
            break
          case 2:
            item.statusStr = '已下线'
            item.time = item.updownTime
            item.timeStr = '下线时间'
            item.actionList = [
              {
                name: '编辑',
                cb: 'edit',
                divider: false
              },
              {
                name: '删除',
                cb: 'delete',
                divider: true
              }
            ]
            break
        }
        if (item.delFlag === 2) {
          item.statusStr = '已删除'
          item.time = item.deleteTime
          item.timeStr = '删除时间'
          item.actionList = [
            {
              name: '恢复',
              cb: 'recovery',
              divider: false
            },
            {
              name: '销毁',
              cb: 'destruction',
              divider: true
            }
          ]
        }
        this.moduleList.forEach((ele) => {
          if (item.moduleId === ele.value) {
            item.moduleStr = ele.label
          }
        })
      })
      this.customOtherOpt.pagination.total = res.total
    },
    //菜单栏点击事件
    menuClick(val) {
      //0发布 1未发布 2下线和未发布 ''查询全部
      if (val.key === '2') {
        this.delFlag = val.key
        this.essayStatus = ''
      } else if (val.key === '1') {
        this.essayStatus = val.key
        this.delFlag = 0
      }
       else {
        this.essayStatus = val.key
        this.delFlag = ''
      }
      this.reset()
    },
    //获取模块列表数据
    async initModuleList() {
      const { data } = await getModuleList(this.params)
      data.forEach((element) => {
        if (element.code !== 'system') {
          this.moduleList.push({
          label: element.menuName,
          value: element.menuId,
          ...element
        })
        }
      })
      this.initTableValue()
    },
    //模块点击事件
    moduleClick(val) {
      this.moduleId = val
      // this.reset()
      this.initTableValue()
    },
    //标题搜索
    titleClick(val) {
      this.essayTitle = val
      this.reset()
    },
    // 查看详情
    detail(val) {
      this.detailVisible = true
      this.title = '详情'
      this.rows = val
    },
    // 下线
    async offline(val) {
      let params = {
        id: val.id,
        status: '2',
        link: editStatus,
        content: '下线后用户将无法看见相关内容。'
      }
      this.commonConfirm(params)
    },
    // 发布
    release(val) {
      let params = {
        id: val.id,
        status: '0',
        link: editStatus,
        limitNum: val.sysMenu.limitNum,
        num: val.num
      }
      this.commonChange(params)
    },
    // 删除
    delete(val) {
      let params = {
        id: val.id,
        delFlag: '2',
        link: editExisted
      }
      this.commonChange(params)
    },
    // 恢复
    recovery(val) {
      let params = {
        id: val.id,
        delFlag: '0',
        link: editExisted
      }
      this.commonChange(params)
    },
    // 销毁
    destruction(val) {
      let params = {
        id: val.id,
        link: deleteExisted,
        content: '销毁后系统将删除此内容。请谨慎！'
      }
      this.commonConfirm(params)
    },
    // 公共提示
    commonConfirm(params) {
      let that = this
      this.$confirm({
        title: '注意',
        content: params.content,
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        async onOk() {
          that.commonChange(params)
        },
        onCancel() {}
      })
    },
    // 公共请求接口
    async commonChange(params) {
      let res = await params.link(params)
      if (res.code === 200) {
        this.$message.success(res.msg)
        this.detailVisible = false
        // this.reset()
        this.moduleList = []
        this.initModuleList()
      } else {
        this.$message.warning(res.msg)
      }
    },
    reset() {
      this.moduleList = []
      this.$refs.table.pagination.pageNum = 1
      this.$refs.table.pagination.current = 1
      this.initModuleList()
    }
  }
}
</script>

<style>
</style>